import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Link } from "react-router-dom";
import { AuthProvider } from './contexts/AuthContext.jsx';
import { App } from './App.jsx';
import { EventProvider } from './contexts/EventContext.jsx';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <AuthProvider>
      <EventProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </EventProvider>
    </AuthProvider>
  </StrictMode>,
);
